/**
 * 메뉴 트리에서 조상 라벨을 누적해 화면 경로를 만든다.
 * Sidebar 검색·탭 menuPath, 프로세스맵 화면 연결이 같은 계산을 쓴다.
 */

export function flattenMenusWithPath(menus, pathLabels = []) {
  const out = [];
  (menus || []).forEach((item) => {
    const label = item.label || item.menuNm || '';
    const nextPath = label ? [...pathLabels, label] : pathLabels;
    const children = item.children || [];
    if (children.length > 0) {
      out.push(...flattenMenusWithPath(children, nextPath));
    } else {
      out.push({
        ...item,
        pathLabels: nextPath,
        pathText: nextPath.join(' › '),
      });
    }
  });
  return out;
}

export function walkMenusWithPath(nodes, visit, pathLabels = []) {
  (nodes || []).forEach((node) => {
    const label = node.label || node.menuNm || '';
    const nextPath = label ? [...pathLabels, label] : pathLabels;
    visit(node, nextPath);
    if (node.children?.length) {
      walkMenusWithPath(node.children, visit, nextPath);
    }
  });
}

function treesAsList(allLeftMenus) {
  if (!allLeftMenus) return [];
  if (Array.isArray(allLeftMenus)) return allLeftMenus;
  return Object.values(allLeftMenus).flat();
}

/** 클릭·조회된 메뉴 항목의 조상 경로. pathLabels가 있으면 그대로 쓴다. */
export function menuPathOf(menuItem, allLeftMenus) {
  if (Array.isArray(menuItem?.pathLabels) && menuItem.pathLabels.length) {
    return menuItem.pathLabels;
  }
  const id = menuItem?.id ?? menuItem?.menuNo;
  if (id != null) {
    const found = flattenMenusWithPath(treesAsList(allLeftMenus)).find(
      (it) => String(it.id ?? it.menuNo) === String(id)
    );
    if (found?.pathLabels?.length) return found.pathLabels;
  }
  const label = menuItem?.label || menuItem?.menuNm;
  return label ? [label] : [];
}
